import { useTranslation } from 'react-i18next'

import { CheckCircleIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Button, FormatNumber, Modal, Text } from '@reveni-io/reveni-ui'

import { zIndexOverDrawer } from '../constants'
import * as Styles from './styles'

const ImportSuccessModal = ({ show, onClose, processedRows }) => {
  const { t } = useTranslation()
  const theme = useTheme()

  return (
    <Modal
      show={show}
      onClose={onClose}
      title={t('Inventario actualizado')}
      size="m"
      zIndex={zIndexOverDrawer}
      actions={
        <Button fullWidth variant="outlined" onClick={onClose}>
          {t('Volver a Inventario')}
        </Button>
      }
    >
      <Styles.Content>
        <CheckCircleIcon size={40} weight="light" color={theme.colors.success.default} />
        <Text type="bodyMRegular">
          {t('Los')}{' '}
          <Text type="bodyMBold" tag="span">
            <FormatNumber>{processedRows}</FormatNumber> {t('productos')}
          </Text>{' '}
          {t('se procesaron sin ningún problema. Tu catálogo está totalmente al día y listo.')}
        </Text>
      </Styles.Content>
    </Modal>
  )
}

export default ImportSuccessModal
